var WDN = WDN || {};

if (typeof WDN.CSSVariable === "undefined") {
  WDN.CSSVariable = (function () {
    // functions
    var set, get;

    // root
    var root = document.documentElement;

    set = function (variable) {
      if (typeof variable.name === "undefined" || typeof variable.value === "undefined") return;
      root.style.setProperty(variable.name, variable.value);
    };

    get = function (name) {
      if (!name) return;
      return getComputedStyle(root).getPropertyValue(name);
    };

    return {
      set,
      get,
    };
  })();
}

if (typeof WDN.Header === "undefined") {
  WDN.Header = (function () {
    // functions
    var init, storeHeight, listenForResize;

    // event handlers
    var windowOnResize;

    // dependencies
    var CSSVariable = WDN.CSSVariable;

    var windowWidth = window.innerWidth;

    var nodes = {
      infoBar: document.querySelector("#shopify-section-announcement-bar"),
      header: document.querySelector("#shopify-section-header"),
    };

    storeHeight = function () {
      var headerHeight = nodes.header.offsetHeight;
      var infoHeight = nodes.infoBar.offsetHeight;

      CSSVariable.set({
        name: "--header-height",
        value: parseInt(headerHeight) + "px",
      });
    };

    windowOnResize = function () {
      if (windowWidth === window.innerWidth) return;
      storeHeight();
      windowWidth = window.innerWidth;
    };

    listenForResize = function () {
      window.addEventListener("resize", windowOnResize);
    };

    init = function () {
      storeHeight();
      listenForResize();
    };

    init();
  })();
}

class WDNDropdown extends HTMLElement {
  constructor() {
    super();
    this.buildConstructor();
    if (!this.autoInit) return;
    this.init();
  }

  configureAttributes() {
    this.nameSpace = this.getAttribute("data-name") || "dropdown";

    this.selectors = {
      trigger: "[" + this.nameSpace + "-trigger]",
      container: "[" + this.nameSpace + "-container]",
      content: "[" + this.nameSpace + "-content]",
    };

    this.attributeList = {
      group: "group",
      active: this.nameSpace + "-active",
      resetHeight: "data-reset-height",
      animation: this.nameSpace + "-animate",
    };
  }

  buildConstructor() {
    this.configureAttributes();
    this.trigger = this.querySelector(this.selectors.trigger);
    this.container = this.querySelector(this.selectors.container);
    this.content = this.querySelector(this.selectors.content);
    this.group = this.getAttribute(this.attributeList.group);
    this.isActive = this.getAttribute(this.attributeList.active) === "";
    this.resetHeight = this.getAttribute(this.attributeList.resetHeight) === "";
    this.animation = parseInt(this.getAttribute(this.attributeList.animation)) || 0;
    this.autoInit = !(this.getAttribute("data-autoinit") === "false");
  }

  setState(newState) {
    this.isActive = newState;
  }

  setContainerHeight(newHeight) {
    var value = newHeight;
    if (typeof newHeight === "number") {
      value = newHeight + "px";
    }
    this.container.style.height = value;
  }

  shrinkContainer() {
    this.setContainerHeight(this.initialHeight);
  }

  expandContainer() {
    var contentHeight = this.content.offsetHeight;
    this.setContainerHeight(contentHeight);
  }

  setInactive() {
    this.expandContainer();
    setTimeout(
      function () {
        this.setState(false);
        this.removeAttribute(this.attributeList.active);
        this.shrinkContainer();

        // this will help when extending the component
        if (typeof this.onClose === "function") {
          this.onClose();
        }
      }.bind(this),
      50
    );
  }

  setActive() {
    this.collapseGroupContainers();
    this.setState(true);
    this.setAttribute(this.attributeList.active, "");
    this.expandContainer();

    // this will help when extending the component
    if (typeof this.onOpen === "function") {
      this.onOpen();
    }
  }

  fireGroupEvent() {
    var customEvent = new CustomEvent("dropdown:group:collapse", {
      detail: { group: this.group },
    });
    document.body.dispatchEvent(customEvent);
  }

  collapseGroupContainers() {
    if (this.group) {
      this.fireGroupEvent();
    }
  }

  beforeInactive() {
    this.expandContainer();
  }

  afterActive() {
    if (!this.animation) return;
    setTimeout(
      function () {
        this.setContainerHeight("auto");
      }.bind(this),
      this.animation
    );
  }

  onTriggerClick() {
    if (this.isActive) {
      this.beforeInactive();
      this.setInactive();
    } else {
      this.setActive();
      this.afterActive();
    }

    if (typeof this.onClick === "function") {
      this.onClick();
    }
  }

  onWindowResize() {
    if (this.isActive) {
      this.expandContainer();
    }
  }

  onGroupCollapse(e) {
    if (this.group === e.detail.group) {
      this.setInactive();
    }
  }

  setInitialState() {
    if (this.isActive) {
      this.expandContainer();
    }
  }

  storeInitialHeight() {
    this.initialHeight = parseInt(this.container.style.height) || 0;
  }

  bind() {
    this.trigger.addEventListener("click", this.onTriggerClick.bind(this));
    document.body.addEventListener("dropdown:group:collapse", this.onGroupCollapse.bind(this));
    window.addEventListener("resize", this.onWindowResize.bind(this));
  }

  init() {
    this.storeInitialHeight();
    this.setInitialState();
    this.bind();
  }
}

if (!customElements.get("wdn-dropdown")) {
  customElements.define("wdn-dropdown", WDNDropdown);
}

class CollectionPagination extends HTMLElement {
  constructor() {
    super();
    this.config = {
      section_id: this.getAttribute("data-pagination-layout"),
    };
    this.nextPageIndex = this.getAttribute("data-next-page");
    this.collectionGrid = document.querySelector("[data-collection-products]");
    this.init();
  }

  appendURLParam() {
    this.currentParams = new URLSearchParams(window.location.search);
    this.currentParams.set("page", this.nextPageIndex);
    window.history.pushState("", "", "?" + this.currentParams.toString());
  }

  removeItself() {
    this.parentNode.remove();
  }

  injectContent(res) {
    var DomParser = new DOMParser();
    var parsedString = DomParser.parseFromString(res, "text/html");
    var responseGrid = parsedString.body.querySelector("[data-collection-products]");
    var responsePagination = parsedString.body.querySelector("[data-collection-pagination]");

    if (responseGrid) {
      this.collectionGrid.insertAdjacentHTML("beforeend", responseGrid.innerHTML);
    }
    if (responsePagination) {
      this.collectionGrid.appendChild(responsePagination);
    }
  }

  handleFetchSuccess(res) {
    this.injectContent(res);
    this.appendURLParam();
    this.isFetching = false;
    this.removeItself();
  }

  handleFetchError(res) {
    this.isFetching = false;
  }

  handleClick() {
    if (this.isFetching) return;
    this.isFetching = true;

    fetch(this.url, {
      method: "GET",
    })
      .then(function (res) {
        return res.ok ? res.text() : Promise.reject(res);
      })
      .then(this.handleFetchSuccess.bind(this))
      .catch(this.handleFetchError.bind(this));
  }

  generateUrl() {
    this.url = this.getAttribute("data-url") + "&section_id=" + this.config.section_id;
  }

  bind() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  init() {
    this.generateUrl();
    this.bind();
  }
}

if (!customElements.get("collection-pagination")) {
  customElements.define("collection-pagination", CollectionPagination);
}

/* Mobile menu dropdowns */
(function () {
  var handleMenuOpen, initDropdowns;
  var dropdownsInited = false;

  // selects menu children dropdowns and inits them
  initDropdowns = function () {
    if (dropdownsInited) return;
    var dropdowns = document.querySelectorAll(".menu-drawer__navigation wdn-dropdown");
    setTimeout(function () {
      dropdowns.forEach(function (dropdown) {
        dropdown.setInitialState();
      });
    }, 200);
    dropdownsInited = true;
  };

  // callback function for menu drawer open
  handleMenuOpen = function () {
    initDropdowns();
  };

  // listens for menu drawer open
  document.addEventListener("menu_drawer:opened", handleMenuOpen);
})();
